import { imageString } from '../../helper';

export function resolveIconSrc(icon) {
  if (icon == null || typeof icon !== 'string') {
    return null;
  }
  const trimmed = icon.trim();
  if (!trimmed) {
    return null;
  }
  if (/^https?:\/\//i.test(trimmed)) {
    return trimmed;
  }
  return imageString(trimmed);
}
